import { useState, useEffect } from 'react';

export default function useBrandName(): string {
  const [brandName, setBrandName] = useState<string>(() => {
    return localStorage.getItem('site_brand_name') || 'COBRAND';
  });

  useEffect(() => {
    const handleUpdate = () => {
      setBrandName(localStorage.getItem('site_brand_name') || 'COBRAND');
    };

    window.addEventListener('site_settings_updated', handleUpdate);
    return () => {
      window.removeEventListener('site_settings_updated', handleUpdate);
    };
  }, []);

  return brandName;
}
